export default class DownloadFile
{
    constructor(fileName){
        this.filename = 'demo';
    }
    getFilePath(filePath= '', fileName = ''){
        let return_data = '';
       if(filePath !=''){
            if(fileName !=''){
                let url = '/download?fp='+btoa(filePath)+'&n='+btoa(fileName); 
                return_data = url;
            }else{
                let url = '/download?fp='+btoa(filePath)+'&n='+btoa(this.filename); 
                return_data = url;
            }
       }else{
           return_data = 0;
       }
        return return_data;
    }
}